import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../_helpers/auth.guard';

import { EcommerceLayoutComponent } from './ecommerce-layout/ecommerce-layout.component';
import { EcommerceDashboaardComponent } from './ecommerce-dashboaard/ecommerce-dashboaard.component';
import { OrdersComponent } from './orders/orders.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { ProductEditComponent } from './Product/product-edit/product-edit.component';
import { ProductListComponent } from './Product/product-list/product-list.component';
import { ProductCreateComponent } from './Product/product-create/product-create.component';
import { CategoriesComponent } from './Product/categories/categories.component';
import { BrandsComponent } from './Product/brands/brands.component';
import { AttributesComponent } from './Product/attributes/attributes.component';
import { OrderAssignedForDeliveryComponent } from './order-assigned-for-delivery/order-assigned-for-delivery.component';
import { OrderProcessComponent } from './order-process/order-process.component';
import { GenerateBillComponent } from './generate-bill/generate-bill.component';
import { DeliveryProcessComponent } from './delivery-process/delivery-process.component';
import { ProductSizeComponent } from './Product/product-size/product-size.component';
import { ProductColorsComponent } from './Product/product-colors/product-colors.component';
import { CouponsComponent } from './coupons/coupons.component';
import { CustomersComponent } from './customers/customers.component';
import { ReturnOrdersComponent } from './return-orders/return-orders.component';
import { PagesComponent } from './pages/pages.component';
import { ShippedOrdersComponent } from './shipped-orders/shipped-orders.component';
import { BannarsComponent } from './Cms/bannars/bannars.component';
import { OutletsComponent } from './outlets/outlets.component';
import { GlobalContentComponent } from './Cms/global-content/global-content.component';
import { MyAccountComponent } from '../my-account/my-account.component';


const routes: Routes = [
  { 
    path: 'ecom', component: EcommerceLayoutComponent, 
    children: [
      { path: '', component: EcommerceDashboaardComponent },
      { 
        path: 'pages', 
        component: PagesComponent,
        data: { page: 'pages' }
      },
      { 
        path: 'products', 
        component: ProductListComponent,
        data: { page: 'products' }
      },
      { 
        path: 'add-product', 
        component: ProductCreateComponent,
        data: { page: 'add-product' }
      },
      { 
        path: 'edit-product/:id', 
        component: ProductEditComponent,
        data: { page: 'edit-product' }
      },
      { 
        path: 'brands', 
        component: BrandsComponent,
        data: { page: 'brands' }
      },
      { 
        path: 'sizes', 
        component: ProductSizeComponent,
        data: { page: 'sizes' }
      },
      { 
        path: 'colors', 
        component: ProductColorsComponent,
        data: { page: 'colors' }
      },
      { 
        path: 'coupons', 
        component: CouponsComponent,
        data: { page: 'coupons' }
      },
      { 
        path: 'customers', 
        component: CustomersComponent,
        data: { page: 'customers' }
      },
      { 
        path: 'categories', 
        component: CategoriesComponent,
        data: { page: 'categories' }
      },
      { 
        path: 'attributes', 
        component: AttributesComponent,
        data: { page: 'attributes' }
      },
      { 
        path: 'orders',
        component: OrdersComponent,
        data: { page: 'orders' }
      },
      { 
        path: 'order-details/:id', 
        component: OrderDetailsComponent,
        data: { page: 'order-details' }
      },
      { 
        path: 'process-orders', 
        component: OrderProcessComponent,
        data: { page: 'process_order' }
      },
      { 
        path: 'order-assigned-for-delivery', 
        component: OrderAssignedForDeliveryComponent,
        data: { page: 'order-assigned-for-delivery' }
      },
      { 
        path: 'shipped-orders', 
        component: ShippedOrdersComponent,
        data: { page: 'shipped-orders' }
      },
      { 
        path: 'generate-bill', 
        component: GenerateBillComponent,
        data: { page: 'generate_bill' }
      },
      { 
        path: 'delivery-process', 
        component: DeliveryProcessComponent,
        data: { page: 'delivery_process' }
      },
      { 
        path: 'order-tracking', 
        component: OrderTrackingComponent,
        data: { page: 'order-tracking' }
      },
      { 
        path: 'return-orders', 
        component: ReturnOrdersComponent,
        data: { page: 'return-orders' }
      },
      { 
        path: 'global-content', 
        component: GlobalContentComponent,
        data: { page: 'global-content' }
      },
      { 
        path: 'bannars', 
        component: BannarsComponent,
        data: { page: 'bannars' }
      },
      { 
        path: 'outlets', 
        component: OutletsComponent,
        data: { page: 'outlets' }
      },
      {
        path: 'my-account',
        component: MyAccountComponent,
        data: { page: 'my-account' }
      }
    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EcommerceRoutingModule { }
